<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h1 class="title">Purchase items</h1></app-cells>
      <app-cells>
        <app-input
          @input.native="onSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by ID, name"
          name="search"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'purchase-items-detail', params: {id: row.id }}" class="table-default__link-border">
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #balance="{ row }">
          {{ row.balance }}
        </template>
        <template #price="{ row }">
          {{ row.price }}$
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { getEquipmentStoragePurchaseItems, putEquipmentStoragePurchaseItems } from '@/http'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'PurchaseItems',
  data() {
    return {
      is_loaded: false,
      search: '',
      table: {
        items: [],
        columns: ['name', 'measurement.name', 'balance', 'price'],
        options: {
          headings: {
            'name': 'Name',
            'measurement.name': 'Unit',
            'balance': 'Current stock',
            'price': 'Price',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      updatedItemId: null,
      table_preloader: false
    }
  },
  validations: {
    form: {
      cost: { required },
      balance: { required },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      getEquipmentStoragePurchaseItems({ page: this.pagination.page, page_size: 20, search: this.search }).then(res => {
        this.table.items = res.data.results
        this.pagination.pages = res.data.pages
        this.pagination.count = res.data.count
        this.is_loaded = true
        this.table_preloader = false
      })
    },
    onCheckForm () {
      this.$v.form.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      putEquipmentStoragePurchaseItems(this.updatedItemId, this.form)
        .finally(() => { this.$refs.submit.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Item updated',
          })
          this.fetchItems()
          this.$modal.hide('rental-form')
          this.form = {}
          this.$v.form.$reset()
        })
    },
    onSearch() {
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>
